import { ComponentType } from 'strapi/component/types';
import { PageType } from 'strapi/page/types';

// The order of components that we need to show in the page
export const pageComponents: Record<PageType, ComponentType[]> = {
  [PageType.CreateLibraryPage]: [
    ComponentType.Seo,
    ComponentType.Breadcrumb,
    ComponentType.HeroSection,
    ComponentType.Carousel,
    ComponentType.CategoryList,
    ComponentType.ImageSection,
    ComponentType.FrequentlyAskedQuestions,
    ComponentType.BottomBanner,
  ],
  [PageType.CreateUseCasePage]: [
    ComponentType.Seo,
    ComponentType.Breadcrumb,
    ComponentType.HeroSection,
    ComponentType.TextImageText,
    ComponentType.Steps,
    ComponentType.TemplateFeed,
    ComponentType.ImageSection,
    ComponentType.Testimonial,
    ComponentType.RelatedLinks,
    ComponentType.FrequentlyAskedQuestions,
    ComponentType.BottomBanner,
  ],
  [PageType.CreateSubUseCasePage]: [
    ComponentType.Seo,
    ComponentType.Breadcrumb,
    ComponentType.HeroSection,
    ComponentType.TextImageText,
    ComponentType.Steps,
    ComponentType.TemplateFeed,
    ComponentType.ImageSection,
    ComponentType.Testimonial,
    ComponentType.RelatedLinks,
    ComponentType.FrequentlyAskedQuestions,
    ComponentType.BottomBanner,
  ],
  TemplatesUseCasePage: [ComponentType.Seo, ComponentType.Breadcrumb],
  TemplatesSubUseCasePage: [ComponentType.Seo, ComponentType.Breadcrumb],
  [PageType.MockupParentPage]: [
    ComponentType.Seo,
    ComponentType.Breadcrumb,
    ComponentType.HeaderBanner,
    ComponentType.Claims,
    ComponentType.ImageSectionSingle,
    ComponentType.ChildrenList,
    ComponentType.Steps,
    ComponentType.ImageSection,
    ComponentType.FrequentlyAskedQuestions,
    ComponentType.BottomBanner,
  ],
  [PageType.MockupChildPage]: [
    ComponentType.Seo,
    ComponentType.Breadcrumb,
    ComponentType.HeaderBanner,
    ComponentType.Claims,
    ComponentType.ImageSectionSingle,
    ComponentType.TextImageText,
    ComponentType.MockupsGroup,
    ComponentType.RelatedLinks,
    ComponentType.Steps,
    ComponentType.ImageSection,
    ComponentType.FrequentlyAskedQuestions,
    ComponentType.BottomBanner,
  ],
  [PageType.AiWritingToolParentPage]: [
    ComponentType.Breadcrumb,
    ComponentType.HeaderBanner,
    ComponentType.ChildrenList,
    ComponentType.ImageSection,
    ComponentType.FrequentlyAskedQuestions,
    ComponentType.BottomBanner,
    ComponentType.Seo,
  ],
  [PageType.AiWritingToolChildPage]: [
    ComponentType.Seo,
    ComponentType.Breadcrumb,
    ComponentType.AiTextTool,
    ComponentType.Carousel,
    ComponentType.TemplateFeed,
    ComponentType.RelatedLinks,
    ComponentType.ImageSection,
    ComponentType.FrequentlyAskedQuestions,
    ComponentType.BottomBanner,
  ],
  [PageType.ToolsLibraryPage]: [
    ComponentType.Seo,
    ComponentType.Breadcrumb,
    ComponentType.HeroSection,
    ComponentType.CategoryList,
    ComponentType.ImageSection,
    ComponentType.FrequentlyAskedQuestions,
    ComponentType.BottomBanner,
  ],
};

// Plural api url for each page.
export const pageApiUrl: Record<PageType, string> = {
  [PageType.CreateLibraryPage]: 'create-library-page',
  [PageType.CreateUseCasePage]: 'create-use-case-pages',
  [PageType.CreateSubUseCasePage]: 'create-sub-use-case-pages',
  [PageType.TemplatesUseCasePage]: 'templates-use-case-pages',
  [PageType.TemplatesSubUseCasePage]: 'templates-sub-use-case-pages',
  [PageType.MockupChildPage]: 'mockup-child-pages',
  [PageType.MockupParentPage]: 'mockup-parent-pages',
  [PageType.AiWritingToolParentPage]: 'ai-writing-parent-pages',
  [PageType.AiWritingToolChildPage]: 'ai-writing-child-pages',
  [PageType.ToolsLibraryPage]: 'tools-library-page',
};
